  /* ══════════════════════════════════════════════════════════════
   STATE
   ══════════════════════════════════════════════════════════════ */
let lockedTier = 4; 
let scrollTimeout;

/* ══════════════════════════════════════════════════════════════
   UI UPDATER: SAVINGS BLOCKS
   ══════════════════════════════════════════════════════════════ */
function updateSavingsDisplay(n) {
  const allBlocks = document.querySelectorAll('.builder-block[data-tier-target]');

  allBlocks.forEach(block => {
    const isTarget = parseInt(block.dataset.tierTarget) === n;
    block.style.display = isTarget ? 'grid' : 'none';
    block.classList.toggle('active', isTarget);
    // For Bundle Products
    document.querySelectorAll('.bundle-block').forEach(bundle => {
      const el = bundle.querySelector('.bundle-builder--wrapper');
      if (!el) return;
      const bundleClass = [...el.classList].find(c => c.startsWith('beauty-bundle-'));
      //console.log(bundleClass); // beauty-bundle-3
      
      if (block.classList.contains('active')) {
        const bundleCount = parseInt(bundleClass.replace('beauty-bundle-', ''));
        const isTarget_ = parseInt(block.dataset.tierTarget) === bundleCount;
        bundle.style.display = isTarget_ ? 'block' : 'none';
      }
    });

  });
}

function jumpTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}


document.addEventListener('click', function (e) {

  const btn = e.target.closest('[data-role="tier-pill"]');
  if (!btn) return;

  // remove active class from all buttons
  document.querySelectorAll('[data-role="tier-pill"]')
    .forEach(b => b.classList.remove('on'));

  // active button
  btn.classList.add('on');

  // selected tier
  const tier = parseInt(btn.dataset.t);

  // update sections
  updateSavingsDisplay(tier);
  setCardStates(tier);

  // optional
  lockedTier = tier;

});



/* ══════════════════════════════════════════════════════════════
   SYNCHRONIZE CLASSES
   ══════════════════════════════════════════════════════════════ */
function setCardStates(tierId) {
  const cards = document.querySelectorAll('.tier-card');
  cards.forEach(card => {
    const isMatch = parseInt(card.dataset.tier) === tierId;
    card.classList.toggle('active', isMatch);
    card.classList.toggle('is-centered', isMatch);
    card.setAttribute('aria-pressed', String(isMatch));
  });
}

/* ══════════════════════════════════════════════════════════════
   CAROUSEL ROTATION LOGIC (Arrows)
   ══════════════════════════════════════════════════════════════ */
function updateArrowVisibility() {
  const grid = document.getElementById('tier-grid');
  const arrowLeft = document.getElementById('arrow-left');
  const arrowRight = document.getElementById('arrow-right');
  
  if (!grid || !arrowLeft || !arrowRight) return;

  // Check if we can scroll left (allow 5px buffer for sub-pixel rendering)
  const canScrollLeft = grid.scrollLeft > 5;
  
  // Check if we can scroll right
  // (ScrollWidth - ClientWidth) is the maximum possible scrollLeft
  const canScrollRight = grid.scrollLeft < (grid.scrollWidth - grid.clientWidth - 5);

  // Toggle visibility classes
  arrowLeft.style.opacity = canScrollLeft ? "1" : "0";
  arrowLeft.style.pointerEvents = canScrollLeft ? "auto" : "none";
  
  arrowRight.style.opacity = canScrollRight ? "1" : "0";
  arrowRight.style.pointerEvents = canScrollRight ? "auto" : "none";
}

/* ══════════════════════════════════════════════════════════════
   UPDATED CAROUSEL STEP
   Removed the "Rotation" logic to respect the "Hide" requirement
   ══════════════════════════════════════════════════════════════ */
function carouselStep(direction) {
  const cards = Array.from(document.querySelectorAll('.tier-card'));
  const currentIndex = cards.findIndex(card => parseInt(card.dataset.tier) === lockedTier);
  
  let nextIndex = currentIndex + direction;

  // If we've reached the start or end, do nothing (don't rotate)
  if (nextIndex < 0 || nextIndex >= cards.length) return;

  const nextTierId = parseInt(cards[nextIndex].dataset.tier);
  selectTier(nextTierId, null, false);
}

/* ══════════════════════════════════════════════════════════════
   INTERSECTION OBSERVER (Mobile Centering)
   ══════════════════════════════════════════════════════════════ */
function initMobileObserver() {
  const grid = document.getElementById('tier-grid');
  
  const observerOptions = {
    root: grid,
    threshold: 0.6, 
  };

  const observer = new IntersectionObserver((entries) => {
    if (window.innerWidth > 860) return;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const centeredTier = parseInt(entry.target.dataset.tier);
        
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          // Only update if the user scrolled to a new tier manually
          if(lockedTier !== centeredTier) {
            lockedTier = centeredTier; 
            setCardStates(centeredTier);
            updateSavingsDisplay(centeredTier);
          }
        }, 50);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.tier-card').forEach((card) => observer.observe(card));
}

/* ══════════════════════════════════════════════════════════════
   SELECT TIER (Explicit Action)
   ══════════════════════════════════════════════════════════════ */

/* ══════════════════════════════════════════════════════════════
   DESKTOP HOVER & INITIALIZATION
   ══════════════════════════════════════════════════════════════ */
function initTierInteractions() {
  const cards = document.querySelectorAll('.tier-card');

  cards.forEach(card => {
    const n = parseInt(card.dataset.tier);

    card.addEventListener('click', (e) => {
      if (e.target.classList.contains('card-cta')) return;
      selectTier(n, e);
    });

    card.addEventListener('mouseenter', () => {
      if (window.innerWidth <= 860) return;
      updateSavingsDisplay(n);
      setCardStates(n);
    });

    card.addEventListener('mouseleave', () => {
      if (window.innerWidth <= 860) return;
      updateSavingsDisplay(lockedTier); 
      setCardStates(lockedTier);
    });
  });
}

function goToBuilder(e) {
  e.stopPropagation();
  const card = e.currentTarget.closest('.tier-card');
  if (card) {
    selectTier(parseInt(card.dataset.tier), null, true);
  }
  jumpTo('builder-section');
}



document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('tier-grid');
  
  initTierInteractions();
  initMobileObserver();
  
  // Listen for scroll events to toggle arrows
  grid.addEventListener('scroll', updateArrowVisibility);
  // Listen for window resize (grid width might change)
  window.addEventListener('resize', updateArrowVisibility);
  
  // Initial setup
  const featured = document.querySelector('.tier-card.featured');
  const startTier = featured ? parseInt(featured.dataset.tier) : 4;
  selectTier(startTier, null, true);
  
  // Check arrows after a small timeout to ensure layout is painted
  setTimeout(updateArrowVisibility, 100);
});

// Update the selectTier function to include visibility check
function selectTier(n, e, silent = false) {
  if (e) e.stopPropagation();
  lockedTier = n;

  setCardStates(n);
  updateSavingsDisplay(n);

  const targetCard = document.getElementById(`card-${n}`);
  const grid = document.getElementById('tier-grid');
  if (targetCard && grid) {
    const scrollPos = targetCard.offsetLeft - (grid.offsetWidth / 2) + (targetCard.offsetWidth / 2);
    grid.scrollTo({ left: scrollPos, behavior: 'smooth' });
    
    // Check arrows again after the smooth scroll completes
    setTimeout(updateArrowVisibility, 350); 
  }

  window.dispatchEvent(new CustomEvent('blinc:tierSelected', { detail: { tier: n } }));
}


